var React = require('react');

function IconEllipsisSolidSlim (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"507.3","cy":"491.2","r":"43.2","key":0}),React.createElement("circle",{"cx":"364.5","cy":"491.2","r":"43.2","key":1}),React.createElement("circle",{"cx":"644.2","cy":"491.2","r":"43.2","key":2})]);
}

IconEllipsisSolidSlim.displayName = "IconEllipsisSolidSlim";

IconEllipsisSolidSlim.defaultProps = {"viewBox":"0 0 1000.6 1000.7"};

module.exports = IconEllipsisSolidSlim;

IconEllipsisSolidSlim.default = IconEllipsisSolidSlim;
